<script>
import {Tweet} from 'vue-tweet-embed'

export default {
  functional: true,
  render (h, {props}) {
    const {value, maxwidth} = props.attributes
    return h('div', {
      class: 'tweet-container',
      style: {
        maxWidth: maxwidth || 'auto'
      }
    }, [
      h(Tweet, {
        attrs: {
          id: value
        }
      })
    ])
  }
}
</script>

<style lang="scss">
.tweet-container {
  & > * {
    max-width: 500px;
    margin: 0 auto;
  }

  .twitter-tweet.twitter-tweet-rendered {
    margin: 0 auto !important;
    min-width: 100% !important;
  }
}

</style>
